import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "infos" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "code" }
const _hoisted_5 = {
  key: 0,
  class: "arrow"
}
const _hoisted_6 = { class: "company ellipsis" }
const _hoisted_7 = {
  key: 0,
  class: "progress"
}
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "data" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "line" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "line" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "line" }
const _hoisted_24 = { class: "value" }

import { useI18n } from "vue-i18n";

import { getDate, getHour, getDifference } from "@/common/utils/dates";

import type { EvaluationListType } from "@/common/types/evaluation";

import { baseAvatar, svgIcon } from "@/common/components";

import { statusIcons } from "@/common/settings/register";


export default /*@__PURE__*/_defineComponent({
  __name: 'card-evaluation',
  props: {
    evaluation: {},
    avatarSize: { default: "5rem" },
    active: { type: Boolean },
    showProgress: { type: Boolean, default: true },
    showArrow: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { t } = useI18n();



const statusList: { [key: string]: string } = {
  pending: "time",
  started: "time-b",
  warning: "info",
  canceled: "close",
  finished: "confirmed",
};

const statusColor: { [key: string]: string } = {
  pending: "#666",
  started: "#666",
  warning: "red",
  canceled: "orange",
  finished: "green",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-evaluation", { active: __props.active, 'no-progress': !__props.showProgress }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(baseAvatar), {
        url: __props.evaluation?.company?.avatar?.small,
        size: __props.avatarSize
      }, null, 8, ["url", "size"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(__props.evaluation.code), 1),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: statusColor[__props.evaluation.status] })
            }, [
              _createVNode(_unref(svgIcon), {
                size: "1.35rem",
                icon: statusList[__props.evaluation.status]
              }, null, 8, ["icon"])
            ], 4)
          ]),
          (__props.showArrow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(svgIcon), {
                  icon: __props.active ? 'arrow-right' : 'arrow-down',
                  size: "1rem"
                }, null, 8, ["icon"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.evaluation.company?.name), 1)
      ])
    ]),
    (__props.showProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)("common.labels.total_duration")), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(svgIcon), {
                icon: "time-b",
                size: "2rem"
              }),
              (!__props.evaluation.start_date)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "0m"))
                : _createCommentVNode("", true),
              (__props.evaluation.start_date && !__props.evaluation?.end_date)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(getDifference)(
                    __props.evaluation.start_date,
                    new Date().toISOString(),
                    false
                  ).text), 1))
                : _createCommentVNode("", true),
              (__props.evaluation.start_date && __props.evaluation?.end_date)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(getDifference)(
                    __props.evaluation.start_date,
                    __props.evaluation?.end_date,
                    false
                  ).text), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)("common.labels.progress")), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(__props.evaluation.analysis?.progress ?? 0) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)("common.labels.analysis")), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.pending")) + ": ", 1),
              _createElementVNode("div", _hoisted_20, _toDisplayString(__props.evaluation.analysis?.pending), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.started")) + ": ", 1),
              _createElementVNode("div", _hoisted_22, _toDisplayString(__props.evaluation.analysis?.started), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.concluded")) + ": ", 1),
              _createElementVNode("div", _hoisted_24, _toDisplayString(__props.evaluation.analysis?.concluded), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})